import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    CircularProgress,
    Typography,
} from "@mui/material";
import DeliveryImages from "../../../components/delivery/DeliveryImages";
import { getImagesByBoxId } from "../../../config";

const DeliveryImageDialog = ({ openImageDialog, onClose, token, id_box }) => {
    const [imagesList, setImagesList] = useState([]);
    const [pickupImage, setPickupImage] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchDeliveryImages = async () => {
        getImagesByBoxId(token, id_box)
            .then(resp => resp.json())
            .then(data => {
                if (Array.isArray(data.delivery_images)) {
                    setImagesList(data.delivery_images);
                    setPickupImage(data.pickup_images);
                } else {
                    setImagesList([]);
                    setPickupImage([]);
                }
            })
            .catch(err => {
                console.error("Error getting images:", err);
                setImagesList([]);
                setPickupImage([]);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (openImageDialog && id_box) {
            setLoading(true);
            fetchDeliveryImages();
        }
    }, [openImageDialog, id_box]);

    return (
        <Dialog
            open={openImageDialog}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>Imagenes</DialogTitle>
            <DialogContent>
                {loading ? (
                    <Box display="flex" justifyContent="center" mt={4}>
                        <CircularProgress />
                    </Box>
                ) : imagesList.length === 0 && pickupImage.length === 0 ? (
                    <Typography align="center" mt={4}>
                        No hay imagenes para mostrar.
                    </Typography>
                ) : (
                    <Box>
                        <DeliveryImages images={pickupImage} title="Imagenes de Pickup" />
                        <DeliveryImages images={imagesList} />  
                    </Box>
                )}

            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="outlined">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeliveryImageDialog;
